export default {
    "newpassword": "新密碼",
    "repeatpwd": "再次輸入新密碼",
    "oldpassword": "現有密碼",
    "wrongpassword": "舊密碼不正確",
    "samepassword": "新密碼不能與舊密碼相同",
    "successpassword": "成功, 正在重新導向...",
    "NoEmailExist": "此電郵尚未注冊",
    "Back": "返回",
}